import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame to avoid forced reflow
    let rafId: number | null = null;
    let timer: NodeJS.Timeout | null = null;
    
    rafId = requestAnimationFrame(() => {
      // Small delay to ensure the component has mounted
      timer = setTimeout(() => {
        // Scroll to top with smooth behavior - this is sufficient, no need for scrollTop
        // Using scrollTo is better than modifying scrollTop directly
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }, 100);
    });

    return () => {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      if (timer !== null) {
        clearTimeout(timer);
      }
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop; 